import { useMemo } from 'react';
import { Job } from '@core/generated/gql-types';
import PercentageDifference from './PercentageDifference';

interface FillRateProps {
  filledJobs: Job[];
  unfilledJobs: Job[];
  priorWeekFilledJobs: Job[];
  comparisonLabel: string;
}

const FillRate = ({
  filledJobs,
  unfilledJobs,
  priorWeekFilledJobs,
  comparisonLabel,
}: FillRateProps) => {
  const percentageFilled = useMemo((): number => {
    const totalItems = filledJobs.length + unfilledJobs.length;
    return (filledJobs.length / (totalItems || 1)) * 100;
  }, [filledJobs, unfilledJobs]);

  return (
    <div className="flex h-auto min-h-[140px] flex-row items-center rounded-xl bg-white p-4 shadow">
      <div className="flex h-full flex-1 flex-col justify-between">
        <div className="text-md font-semibold">Fill rate</div>
        <div className="mb-2 text-3xl font-medium">
          {percentageFilled.toFixed(1) + '%'}
        </div>

        <PercentageDifference
          currentValue={filledJobs.length}
          priorValue={priorWeekFilledJobs.length}
          comparisonLabel={comparisonLabel}
        />
      </div>
    </div>
  );
};

export default FillRate;
